import React from 'react';
import BuscaForm from '../../gww-lib/busca-no-form/index';
import CampoTextoAjuda from '../../gww-lib/campo-texto-ajuda';

export default function DadosNota(props) {
    const {
        cpf,
        setCpf,
        cpfErro,
        cpfErroTexto,
        cfop,
        setCfop,
        cfopErro,
        cfopErroTexto,
        descricaoCfop,
        setDescricaoCfop,
        inativo
    } = props;
    return (
        <>

            <CampoTextoAjuda
                label="CPF/CNPJ"
                error={cpfErro}
                helperText={cpfErroTexto}
                value={cpf}
                type={`number`}
                obrigatorio={false}
                disabled={inativo}
                onChange={e => setCpf(e.target.value)}
                tituloAjuda="CPF/CNPJ"
                textoAjuda="Caso queira informar um CPF/CNPJ do cliente, preencha esse campo."
                saibaMais={{
                    categoria: 'nfce',
                    campo: 'cpf/cnpj'
                }}
            />

            {/* <BuscaForm
                codigo={cliente}
                tabela="PESSOA"
                label="Cliente"
                consultaInstantanea
                setCodigoPai={(cliente) => setCliente(cliente)}
                setDescricao={setDescricaoCliente}
                descricao={descricaoCliente}
                procedureConsulta="WEBSITE_LIST_GPESSOA_L_ATIVO"
                filtro="CDSPESS"
                erroTexto={clienteErroTexto}
                erro={clienteErro}
                inativo={inativo}
                ajuda={{
                    obrigatorio: true,
                    tituloAjuda: 'Cliente',
                    textoAjuda: 'Informar o código  do cliente ou pesquise o cliente , basta clicar na lupa para pesquisar.',
                    saibaMais: {
                        categoria: 'nfe',
                        campo: 'cliente'
                    }
                }}
            /> */}

            <BuscaForm
                codigo={cfop}
                tabela="CFOPNFCE"
                label="CFOP"
                erroTexto={cfopErroTexto}
                erro={cfopErro}
                setCodigoPai={(cfop) => setCfop(cfop)}
                descricao={descricaoCfop}
                setDescricao={setDescricaoCfop}
                procedureConsulta="WEBSITE_LISTAGEM_TCFOP_NFCE"
                consultaInstantanea
                inativo={inativo}
                ajuda={{
                    obrigatorio: true,
                    tituloAjuda: 'CFOP',
                    textoAjuda: '(Código Fiscal de Operações e Prestações) , informar a CFOP para a operação da NF-e , caso haja dúvidas verificar está informação com o contador ou responsável fiscal pela empresa.',
                    saibaMais: {
                        categoria: 'nfe',
                        campo: 'cfop'
                    }
                }}
            />
        </>

    )
}